import {RecordEnum} from '@/components/timeline/Record/RecordEnum'

const state = {
    recordDialogVisible: false, // 录音弹窗
    recordStatus: RecordEnum.RecordInit, // 录音状态
    recordIndex: 1, // 录音编号
    left: 0
}
const mutations = {
    recordDialogShow(state) {
        state.recordDialogVisible = true
    },
    recordDialogHide(state) {
        state.recordDialogVisible = false
    },
    changeRecordStatus(state, value) {
        state.recordStatus = value
    },
    setRecordIndex(state, value) {
        state.recordIndex = value
    },
    setOffsetLeft(state, value) {
        state.left = value
    }
}
export default {
    namespaced: true,
    state,
    mutations
}